import { Trans, useTranslation } from 'next-i18next';

import { TrialCta } from '../components/trial-cta';
import { CONTAINER_CLASS, EYEBROW_CLASS, GOLD_EM_CLASS, SECTION_CLASS, SECTION_TITLE_CLASS, SectionBackground } from '../components/ui';
import { FAQ_COUNT, FINAL_FORM_ANCHOR, V4A_NAMESPACE } from '../constants';

const QUESTIONS = Array.from({ length: FAQ_COUNT }, (_question, index) => index);

/** "Feitiços frequentes": the questions people ask before the counter-spell. Native <details>. */
export function Faq() {
  const { t } = useTranslation(V4A_NAMESPACE);
  return (
    <section className={`${SECTION_CLASS} sec--faq`} id='feiticos' aria-labelledby='faq-title'>
      <SectionBackground />
      <div className={CONTAINER_CLASS}>
        <div className='faq__grid grid items-start gap-[clamp(2rem,_1rem_+_3vw,_3.5rem)] lg:grid-cols-[minmax(0,_.82fr)_minmax(0,_1.18fr)] lg:gap-[clamp(2.5rem,_1rem_+_4vw,_5rem)]'>
          <div className='faq__aside min-w-0 lg:sticky lg:top-[calc(var(--header-h)_+_2rem)]' data-reveal=''>
            <p className={EYEBROW_CLASS}>{t('faq.eyebrow')}</p>
            <h2 className={SECTION_TITLE_CLASS} id='faq-title'>
              <Trans t={t} i18nKey='faq.title' components={{ em: <em className={GOLD_EM_CLASS} /> }} />
            </h2>
            <p className='sec__lead m-0 mt-4 max-w-[34em] text-[length:var(--fs-lg)] leading-[1.6] text-[color:var(--fg-muted)]'>{t('faq.lead')}</p>
            <TrialCta className='btn btn-primary relative isolate mt-6 inline-flex min-h-[var(--x-h)] items-center justify-center gap-2 whitespace-normal px-5 py-0 text-center text-[length:var(--fs-sm)] font-bold uppercase leading-[1.2] tracking-[.05em] no-underline [--x-h:3.25rem] min-[641px]:px-8 min-[641px]:py-0 min-[641px]:tracking-[var(--ls-caps)]' anchor={FINAL_FORM_ANCHOR}>
              {t('cta.try_free')}
            </TrialCta>
          </div>
          <div className='faq__list grid min-w-0 gap-3' data-reveal=''>
            {QUESTIONS.map((index) => (
              <details key={index} className='faq__item overflow-hidden'>
                <summary className='flex min-w-0 cursor-pointer list-none items-center justify-between gap-4 p-5 text-[length:var(--fs-lg)] font-semibold'>
                  <span>{t(`faq.items.${index}.q`)}</span>
                  <i className='relative size-7 flex-none' aria-hidden='true' />
                </summary>
                <div className='faq__a min-w-0 p-5 pt-0'>
                  <p className='m-0 max-w-[40em] text-[length:var(--fs-md)] leading-[1.65] text-[color:var(--fg-dim)]'>
                    <Trans t={t} i18nKey={`faq.items.${index}.a`} components={{ b: <b className='font-semibold text-[color:var(--fg)]' /> }} />
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
